import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";
import requiresAuthentication from "auth/requiresAuthentication";
import ManagerPanel from "manager-panel/ManagerPanel";
import ManagerPanelHome from "home/ManagerPanelHome";
import ManageSipServers from "security-settings/sip-servers/components/ManageSipServers";

import CreatorApplication from "creator-application/CreatorApplication";

import Error from "application/components/Error";
import Login from "application/components/Login";

import withAuthorization from "auth/withAuthorization";
import ManagePapiServers from "../../security-settings/papi-servers/components/ManagePapiServers";
import UserAdminApplication from "../../user-admin/UserAdminApplication";
import ModuleGroupsApplication from "../../manage-module-groups/ModuleGroupsApplication";
import ManageBadges from "../../manage-badges/ManageBadges";
import ManageSftpAccounts from "../../security-settings/sftp-accounts/components/ManageSftpAccounts";
import ManageRipEndpoints from "../../manage-rip-endpoints/ManageRipEndpoints";
import ManageApplicationAccounts from "../../manage-application-accounts/ManageApplicationAccounts";
import ManageIpOverrides from "../../security-settings/region-ip-override/ManageIpOverrides";
import ManageAuthentication from "../../manage-authentication/ManageAuthentication";
import ManageSubscriptions from "../../manage-subscriptions/ManageSubscriptions";
import ManageOrganizations from "../../manage-organizations/ManageOrganizations";
import ManageCSPs from "../../manage-csp/ManageCSPs";
import MetadataFileDiscoveryReport from "../../manage-processing/discovery-reporting/MetadataFileDiscoveryReport";
import ManageContentProviders from "../../manage-content-providers/ManageContentProviders";

import BrowseMedia from "browse-media/components/BrowseMedia";
import ManageModules from "manage-modules/components/ManageModules";
import { AlertProvider } from "../../components/alert/AlertProvider";
// import AnthologyBrowse from "manage-anthologies/components/AnthologyBrowse";
// import CollectionBrowse from "manage-collections/components/CollectionBrowse";

const AuthenticatedManagerPanel = requiresAuthentication(ManagerPanel);
const AuthorizedRoute = withAuthorization(Route);

const Application = ({ history }) => {
  return (
    <AlertProvider>
      <ConnectedRouter history={history}>
        <Switch>
          <Route path="/login" component={Login} />
          <Route path="/error" component={Error} />
          <Route
            path="/"
            render={({ location }) => {
              return (
                <AuthenticatedManagerPanel location={location}>
                  <Switch>
                    <Route exact path="/">
                      <Redirect to="/home" />
                    </Route>

                    <Route path="/home" component={ManagerPanelHome} />
                    <AuthorizedRoute
                      path="/manage-csp"
                      roles={["ROLE_ADMIN"]}
                      component={ManageCSPs}
                    />

                    <AuthorizedRoute
                      path="/user-admin"
                      roles={["ROLE_ADMIN"]}
                      component={UserAdminApplication}
                    />

                    <AuthorizedRoute
                      path="/rip-endpoints"
                      roles={["ROLE_ADMIN"]}
                      component={ManageRipEndpoints}
                    />

                    <AuthorizedRoute
                      path="/content-providers"
                      roles={["ROLE_ADMIN"]}
                      component={ManageContentProviders}
                    />

                    <AuthorizedRoute
                      path="/manage-badges"
                      roles={["ROLE_ADMIN"]}
                      component={ManageBadges}
                    />

                    <AuthorizedRoute
                      path="/manage-organizations"
                      roles={["ROLE_ADMIN"]}
                      component={ManageOrganizations}
                    />

                    <AuthorizedRoute
                      path="/manage-authentication"
                      roles={["ROLE_ADMIN"]}
                      component={ManageAuthentication}
                    />

                    <AuthorizedRoute
                      path="/manage-subscriptions"
                      roles={["ROLE_ADMIN"]}
                      component={ManageSubscriptions}
                    />

                    <AuthorizedRoute
                      path="/region-ip-override"
                      roles={["ROLE_ADMIN"]}
                      component={ManageIpOverrides}
                    />
                    <AuthorizedRoute
                      path="/sip-servers"
                      roles={["ROLE_ADMIN"]}
                      component={ManageSipServers}
                    />
                    <AuthorizedRoute
                      path="/sftp-accounts"
                      roles={["ROLE_ADMIN"]}
                      component={ManageSftpAccounts}
                    />
                    <AuthorizedRoute
                      path="/papi-servers"
                      roles={["ROLE_ADMIN"]}
                      component={ManagePapiServers}
                    />
                    <AuthorizedRoute
                      path="/manage-application-accounts"
                      roles={["ROLE_ADMIN"]}
                      component={ManageApplicationAccounts}
                    />

                    <AuthorizedRoute
                      path="/manage-module-groups"
                      roles={["ROLE_ADMIN"]}
                      component={ModuleGroupsApplication}
                    />

                    <AuthorizedRoute
                      path="/metadata-discovery-report"
                      roles={["ROLE_ADMIN"]}
                      component={MetadataFileDiscoveryReport}
                    />

                    {/* [TODO]: DEPRECATED - remove once Cara audits for all missing features in new Creator */}
                    <AuthorizedRoute
                      path="/manage-modules"
                      roles={["ROLE_ADMIN", "ROLE_CONTENT_MANAGER"]}
                      component={ManageModules}
                    />
                    <AuthorizedRoute
                      path="/browse-media"
                      roles={["ROLE_ADMIN", "ROLE_CONTENT_MANAGER"]}
                      component={BrowseMedia}
                    />
                    {/* <AuthorizedRoute
                    path="/browse-anthologies"
                    roles={["ROLE_ADMIN", "ROLE_CONTENT_MANAGER"]}
                    component={AnthologyBrowse}
                  />
                  <AuthorizedRoute
                    path="/browse-collections"
                    roles={["ROLE_ADMIN", "ROLE_CONTENT_MANAGER"]}
                    component={CollectionBrowse}
                  /> */}
                    {/* END DEPREPCATED */}

                    <AuthorizedRoute
                      path="/creator"
                      roles={[
                        "ROLE_ADMIN",
                        "ROLE_CREATOR_MANAGER",
                        "ROLE_CREATOR_USER",
                        "ROLE_CONTENT_MANAGER",
                      ]}
                      component={CreatorApplication}
                    />

                    <Route>
                      <Redirect to="/home" />
                    </Route>
                  </Switch>
                </AuthenticatedManagerPanel>
              );
            }}
          />
        </Switch>
      </ConnectedRouter>
    </AlertProvider>
  );
};

export default Application;
